import { generateGameId, isValidGameId } from './gameId';

export function generateGroupToken(): string {
  // Id grupy powinien być czytelny (taki jak dawny gameId)
  return generateGameId();
}

export function normalizeGroupToken(raw?: string | null): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  return trimmed.toUpperCase();
}

export function isValidGroupToken(token?: string | null): boolean {
  if (!token) return false;
  return isValidGameId(token.trim().toUpperCase());
}
